@if (show) {
  <div class="fixed text-lg bottom-10 left-1/2 transform -translate-x-1/2 py-2 px-8 border border-kaz-orange rounded-full shadow-md flex flex-col bg-kaz-orange/80 backdrop-blur text-white">
    @if (title) {
      <span class="font-semibold">{{title}}</span>
    }
    @if (description) {
      <span class="text-sm font-semibold">{{description}}</span>
    }
  </div>
}
